module.exports = __webpack_public_path__ + "img/logo-shuyi-light-mode.80095178.svg";